/**
 * Product badges: modals + delivery label by country.
 */
(function () {
  var MODALS = [
    { id: 'modal-price-match', name: 'price-match' },
    { id: 'modal-shipping', name: 'shipping' },
    { id: 'modal-authenticity', name: 'authenticity' },
    { id: 'modal-sales-tax', name: 'sales-tax' }
  ];

  function initModals() {
    if (typeof theme === 'undefined' || !theme.Modals) {
      return;
    }

    MODALS.forEach(function (config) {
      var el = document.getElementById(config.id);
      if (!el || el.dataset.badgeModalReady === 'true') {
        return;
      }

      new theme.Modals(config.id, config.name, { solid: true });
      el.dataset.badgeModalReady = 'true';
    });
  }

  function updateDeliveryLabel() {
    var delivery = document.getElementById('delivery-svg');
    if (!delivery) {
      return;
    }

    var us = delivery.dataset.deliveryUs;
    var intl = delivery.dataset.deliveryIntl;
    var country = window.Shopify && Shopify.country ? Shopify.country : 'US';

    delivery.textContent = country === 'US' ? us : intl;
  }

  function init() {
    initModals();
    updateDeliveryLabel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
